import { useEffect, useState } from 'react'

const useWindowSize = () => {
    const rootDiv = document.getElementById("root")

    const [windowSize, setWindowSize] = useState({width: window.innerWidth, height:rootDiv.clientHeight});
    useEffect(()=>{
        window.addEventListener("resize", resizeHandler);
        return()=>{
            window.removeEventListener("resize", resizeHandler)
        };
    });
    const resizeHandler = ()=>{
        setWindowSize({width: window.innerWidth, height:rootDiv.clientHeight});
    };
    return windowSize;
};

export {useWindowSize}